function slickMainPromo() {
    var options = {
        lazyLoad: 'ondemand',
        dots: false,
        speed: 300,
        arrows: true,
        infinite: true,
        draggable: false,
        pauseOnHover: true,
        fade: true,
        adaptiveHeight: true,
        prevArrow: '<button class="slick-prev slick-prev--main-promo"></button>',
        nextArrow: '<button class="slick-next slick-next--main-promo"></button>'
    };


    var $target = $('#slider-promo');

    if ($target.length != 0) {
        $target.slick(options);
    }
}

function slickMainCatalog() {

    var options = {
        lazyLoad: 'ondemand',
        dots: true,
        speed: 300,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        pauseOnHover: true,
        autoplay: true,
        autoplaySpeed: 5000
    };

    var $target = $('#slider-main-catalog');

    if ($target.length == 0) {
        return null;
    }

    var init = function() {

        var res = resolutionCheck();

        if (res <= 64 && !$target.hasClass('slick-initialized')) {
            $target.slick(options);
        }

        if (res > 64 && $target.hasClass('slick-initialized')) {
            $target.slick('unslick');
        }

    };

    init();

    $(window).on('resize orientationchange', function() {
        init();
    });
}

function slickDeserts() {
    var options = {
        lazyLoad: 'ondemand',
        dots: false,
        speed: 300,
        arrows: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        variableWidth: false,
        infinite: true,
        draggable: false,
        pauseOnHover: true,
        appendArrows: '#slider-main-carousel + .main-carousel__slide-arrows',
        prevArrow: '<button class="slick-prev slick-prev--main-carousel"></button>',
        nextArrow: '<button class="slick-next slick-next--main-carousel"></button>',
        responsive: [{
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 960,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    // variableWidth: false
                }
            }
        ]
    };


    var $target = $('#slider-main-carousel');

    if ($target.length != 0) {
        $target.slick(options);
    }
}
function slickPhotoCakeOrder() {

    var options = {
        lazyLoad: 'ondemand',
        dots: true,
        speed: 300,
        arrows: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        pauseOnHover: true,
        adaptiveHeight: true,
        appendDots: '.photo-steps__mobile-dots'
    };

    var $target = $('#photo-steps');

    if ($target.length == 0) {
        return null;
    }

    var init = function () {

        var res = resolutionCheck();

        if (res <= 32 && !$target.hasClass('slick-initialized')) {
            $target.slick(options);
        }

        if (res > 32 && $target.hasClass('slick-initialized')) {
            $target.slick('unslick');
        }

    };

    init();

    $(window).on('resize orientationchange', function () {
        init();
    });
}
$(document).ready(function() {
    slickMainPromo();
    slickMainCatalog();
    slickDeserts();
    slickPhotoCakeOrder();
});
